import { useTranslation } from 'react-i18next';
import { ModulePlaceholderForm } from '../../components/ModulePlaceholderForm';

export default function NewTraining() {
  const { t } = useTranslation('panel');
  return (
    <ModulePlaceholderForm
      title="New training program"
      listPath="/panel/trainings"
      tabs={[
        {
          key: 'basic',
          label: t('form.tabs.basic'),
          fields: [
            { key: 'name', label: 'Program name', required: true },
            { key: 'category', label: 'Category', type: 'select', options: [
              { value: 'technical', label: 'Technical' },
              { value: 'soft-skills', label: 'Soft skills' },
              { value: 'compliance', label: 'Compliance' },
              { value: 'leadership', label: 'Leadership' },
            ] },
            { key: 'trainerName', label: 'Trainer / vendor' },
          ],
        },
        {
          key: 'details',
          label: t('form.tabs.details'),
          fields: [
            { key: 'startDate', label: 'Start date', type: 'date', required: true },
            { key: 'endDate', label: 'End date', type: 'date' },
            { key: 'durationHours', label: 'Duration (hours)', type: 'number' },
            { key: 'mode', label: 'Mode', type: 'select', options: [
              { value: 'classroom', label: 'Classroom' },
              { value: 'online', label: 'Online' },
              { value: 'hybrid', label: 'Hybrid' },
            ] },
            { key: 'description', label: 'Description', type: 'textarea' },
          ],
        },
        {
          key: 'documents',
          label: t('form.tabs.documents'),
          fields: [
            { key: 'budget', label: 'Budget (₹)', type: 'number' },
            { key: 'maxParticipants', label: 'Max participants', type: 'number' },
            { key: 'materialsUrl', label: 'Materials URL' },
          ],
        },
        { key: 'review', label: t('form.tabs.review'), fields: [] },
      ]}
    />
  );
}
